import { Container } from "@jds/core";

import bccis from "../../images/bcci.jpg";
import instalogos from "../../images/instalogo.png";

import "./FizzyMemories.css";

const FizzyMemories = () => {
  return (
    <div>
      <Container
        className="layout-container"
        style={{
          background: "linear-gradient(91deg, #441e8f -12.2%, #596dd6 99.18%)",
          position: "relative",
          boxSizing: "border-box",
          display: "grid",
          gridTemplateColumns: "35% 65%",
        }}
      >
        <div
          className="fixed"
          style={{
            padding: "87px 4.3vw 87px 9.375vw",
            marginBottom: "0",
            flex: "1",
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
            <img
              style={{
                width: "38px",
                height: "38px",
                marginBottom: "20px",
                // marginRight: "70%",
                textAlign: "left",
              }}
              src={instalogos}
              alt="Logo"
            />
          </div>
          <p
            className="compress"
            style={{
              color: "#fff",
              fontSize: "24px",
              lineHeight: "normal",
              fontFamily: "LogikWide",
              textAlign: "left",
              whiteSpace: "pre-wrap",
              marginBottom: "20px",
            }}
          >
            CAPTURING THE
            <br />
            SPIRIT OF INDIA
            <br />
            THROUGH
          </p>
          {/* <h5 className='fontcompress' style={{ fontFamily: 'LogikWide', color: '#fff', fontSize: '64px', fontStyle: 'italic', textShadow: '5px 5px 0 #441e8f', marginTop: '11px', lineHeight: '1.05' }}><span style={{ marginRight: '100px' }}>THE</span> <br /> GREAT <br /> INDIAN <br /><span style={{ marginRight: '20px' }}>TASTE</span> </h5> */}
          <h5
            className="fontcompress heading-text"
            style={{
              fontFamily: "LogikWide",
              color: "#fff",
              fontStyle: "italic",
              textShadow: "5px 5px 0 #441e8f",
              marginTop: "11px",
              lineHeight: "1.1",
            }}
          >
            <span className="line-1">THE GREAT</span>
            <br />
            <span className="line-2">INDIAN TASTE</span>
          </h5>
        </div>

        <div
          className="scrolling"
          style={{
            overflowX: "hidden",
            // overflowX: 'scroll',
            whiteSpace: "nowrap",
            display: "flex",
            // alignItems: 'flex-start',
            position: "relative",
            width: "100%",
            // minWidth:'100%',
            overflow: "hidden",
          }}
        >
          <div
            className="speed"
            style={{
              display: "inline-flex",
              animation: "scrollFizzy 25s linear infinite",
            }}
          >
            <img
              alt="campa-cola-new"
              className="multipleimages"
              style={{ width: "620px", height: "630px", objectFit: "cover" }}
              src="https://campabeveragesadmin.ril.com/uploads/Campa_Cola_new_ecdb252ea6.jpg"
            />
            <img
              alt="bccis"
              className="multipleimages"
              style={{ width: "620px", height: "630px", objectFit: "cover" }}
              src={bccis}
            />
            <img
              alt="bcci-post"
              className="multipleimages"
              style={{ width: "620px", height: "630px", objectFit: "cover" }}
              src="https://campabeveragesadmin.ril.com/uploads/BCCI_Post_489277ee3e.jpg"
            />
            <img
              alt="campa-lemon"
              className="multipleimages"
              style={{ width: "620px", height: "630px", objectFit: "cover" }}
              src="https://campabeveragesadmin.ril.com/uploads/campa_lemon_post_V2_a1dca2bf59.jpg"
            />
            <img
              alt="india-final"
              className="multipleimages"
              style={{ width: "620px", height: "630px", objectFit: "cover" }}
              src="https://campabeveragesadmin.ril.com/uploads/INDIA_FINAL_b8d06bf716.jpg"
            />
            <img
              alt="campa-cola"
              className="multipleimages"
              style={{ width: "620px", height: "630px", objectFit: "cover" }}
              src="https://campabeveragesadmin.ril.com/uploads/Campa_Cola_8728b089e2.jpg"
            />

            <img
              alt="campa-cola-new"
              className="multipleimages"
              style={{ width: "620px", height: "630px", objectFit: "cover" }}
              src="https://campabeveragesadmin.ril.com/uploads/Campa_Cola_new_ecdb252ea6.jpg"
            />
            <img
              alt="bccis"
              className="multipleimages"
              style={{ width: "620px", height: "630px", objectFit: "cover" }}
              src={bccis}
            />
            <img
              alt="bcci-post"
              className="multipleimages"
              style={{ width: "620px", height: "630px", objectFit: "cover" }}
              src="https://campabeveragesadmin.ril.com/uploads/BCCI_Post_489277ee3e.jpg"
            />
            <img
              alt="campa-lemon"
              className="multipleimages"
              style={{ width: "620px", height: "630px", objectFit: "cover" }}
              src="https://campabeveragesadmin.ril.com/uploads/campa_lemon_post_V2_a1dca2bf59.jpg"
            />
            <img
              alt="india-final"
              className="multipleimages"
              style={{ width: "620px", height: "630px", objectFit: "cover" }}
              src="https://campabeveragesadmin.ril.com/uploads/INDIA_FINAL_b8d06bf716.jpg"
            />
            <img
              alt="campa-cola"
              className="multipleimages"
              style={{ width: "620px", height: "630px", objectFit: "cover" }}
              src="https://campabeveragesadmin.ril.com/uploads/Campa_Cola_8728b089e2.jpg"
            />
          </div>
        </div>
      </Container>
    </div>
  );
};

export default FizzyMemories;
